// Stable per-camera gradient picker, shared by the v7 CameraTile and the
// dashboards overview / switcher previews so a tile keeps the same
// "feed" color on every surface it appears on.
//
// Pulled out of CameraTile.tsx so that file stays component-only (the
// react-refresh/only-export-components rule otherwise warns when a TSX
// file exports a non-component helper alongside its component).

const FEED_GRADIENTS: readonly string[] = [
  "linear-gradient(135deg, #2c3e50 0%, #4ca1af 100%)",
  "linear-gradient(135deg, #485563 0%, #29323c 100%)",
  "linear-gradient(135deg, #1f4037 0%, #99f2c8 100%)",
  "linear-gradient(135deg, #232526 0%, #414345 100%)",
  "linear-gradient(135deg, #355c7d 0%, #6c5b7b 50%, #c06c84 100%)",
  "linear-gradient(135deg, #134e5e 0%, #71b280 100%)",
  "linear-gradient(135deg, #4b6cb7 0%, #182848 100%)",
  "linear-gradient(135deg, #283c86 0%, #45a247 100%)",
  "linear-gradient(135deg, #614385 0%, #516395 100%)",
  "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
  "linear-gradient(135deg, #3a6073 0%, #16222a 100%)",
  "linear-gradient(135deg, #16a085 0%, #f4d03f 100%)",
  "linear-gradient(135deg, #232526 0%, #485563 100%)",
  "linear-gradient(135deg, #136a8a 0%, #267871 100%)",
  "linear-gradient(135deg, #44a08d 0%, #093637 100%)",
  "linear-gradient(135deg, #5d4157 0%, #a8caba 100%)",
];

/**
 * djb2-ish hash → bucket into a stable gradient. Same input → same
 * gradient on every reload, so the wall reads as a wall and not as a
 * sea of identical placeholders.
 */
export function feedGradientFor(doorbotId: string): string {
  let hash = 5381;
  for (let i = 0; i < doorbotId.length; i++) {
    hash = ((hash << 5) + hash + doorbotId.charCodeAt(i)) | 0;
  }
  const idx = Math.abs(hash) % FEED_GRADIENTS.length;
  return FEED_GRADIENTS[idx] ?? FEED_GRADIENTS[0]!;
}
